import React from 'react';
import queryString from 'query-string';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';
import {ResultBox, TextForm, Modal} from 'components';
import * as Styles from 'pages/function3-result/styles';
import config from '../../config';
import parseQueryAndVerifyAuth from '../../service/parseQueryAndVerifyAuth';
import verifySignatureRequest from '../../service/verifySignatureRequest';

const serviceId = config.mykeepin.serviceId;
const type = config.mykeepin.authType.function3;

// Page function3 (페이지명은 추후에 바뀔 수 있음)
class function3_result extends React.Component {
  state = {
    statusCode: '',
    modalVisible: false,
    verificationResult: false,
    signatureVerificationResult: false,
    description: '',
    input: {
      code: '',
      serviceId: serviceId,
      state: '',
      type: type,
      sampleStringData: '',
      metaId: '',
      signature: '',
    },
  }

  render() {
    return (
      <Styles.PageLayout>
        {/* Modal window */}
        <Modal
          status={this.state.signatureVerificationResult} /* success / fail */
          visible={this.state.modalVisible} /* boolean */
          title={this.state.signatureVerificationResult === true ? 'Signature is verified' : 'Signature verfication failed'}
          content="This section contains an error description. I think It'll look a little longer, so I'm just writing. A little more will do."
          onClickConfirm={this.onClickConfirm} /* on click confirm button of modal window */
        />

        <Styles.GridLayout>
          {/* 결과 출력하는 영역 제외한 부분 */}
          <Styles.LeftSideLayout>
            {/* coinplug logo */}
            <Styles.LogoContainer>
              <Styles.Logo src={coinplug_logo} alt="coinplug-logo" />
            </Styles.LogoContainer>

            {/* 페이지 title */}
            <Styles.PageTitle>
              PUSH SAMPLE
            </Styles.PageTitle>

            {/* 샘플 텍스트 */}
            <Styles.Paragraph>
              Metadium DID 기반 인증 서비스를 테스트합니다. Meta ID를 입력하면 특정 유저에게 푸시 알림을 보낼 수 있습니다. 또한 인증 절차는 입력하신 Meta ID 만이 진행할 수 있습니다. Data 입력 시 Signature 를 위한 Nonce 값에 입력한 문자의 Hash 값이 추가됩니다.
            </Styles.Paragraph>
          </Styles.LeftSideLayout>

          {/* 결과 출력하는 박스 */}
          <Styles.ResultBoxContainer>
            <ResultBox
              style={{ width: "100%", height: "100%" }}
              status={this.state.verificationResult}
              status_code={this.state.statusCode}
              description={this.state.description}
              icon_margin={"56px"}
            >
              {/* Code showing field */}
              <TextForm
                style={{ margin: "76px 32px 24px 32px" }}
                header="Code"
                name="code"
                value={this.state.input.code}
                onChange={this.handleChange}
              />

              {/* Service ID showing field */}
              <TextForm
                style={{ margin: "0px 32px 24px 32px" }}
                header="Service ID"
                name="serviceId"
                value={this.state.input.serviceId}
                onChange={this.handleChange}
              />

              {/* State showing field */}
              <TextForm
                style={{ margin: "0px 32px 24px 32px" }}
                header="State"
                name="state"
                value={this.state.input.state}
                onChange={this.handleChange}
              />

              {/* Sample String Data showing field */}
              <TextForm
                style={{ margin: "0px 32px 24px 32px" }}
                header="Sample String Data"
                name="sampleStringData"
                value={this.state.input.sampleStringData}
                onChange={this.handleChange}
              />

              {/* Meta ID showing field */}
              <TextForm
                style={{ margin: "0px 32px 24px 32px" }}
                header="Meta ID"
                name="metaId"
                value={this.state.input.metaId}
                onChange={this.handleChange}
              />

              {/* Signature showing field */}
              <TextForm
                style={{ margin: "0px 32px 0px 32px" }}
                header="Signature"
                name="signature"
                value={this.state.input.signature}
                onChange={this.handleChange}
              />

              {/* Verify signature button */}
              <Styles.ButtonContainer>
                <this.VerifySignatureButton />
              </Styles.ButtonContainer>
            </ResultBox>
          </Styles.ResultBoxContainer>
        </Styles.GridLayout>
      </Styles.PageLayout>
    );
  }

  async componentDidMount () {
    const input = this.state.input;
    // Load input from previous page " /function3 "
    input['metaId'] = localStorage.getItem('metaId') || '';
    input['sampleStringData'] = localStorage.getItem('sampleStringData') || '';
    
    const dataHash = input['sampleStringData'];
    const { state = '', code = '' } = queryString.parse(this.props.location.search);
    input['state'] = state;
    input['code'] = code;

    // 인증 정보 검증 요청
    const res = await parseQueryAndVerifyAuth.call(this, type, dataHash);
    if (res) {
      const { did, signature } = res;
      input['metaId'] = did;
      input['signature'] = signature;
    }
  
    this.setState({ input });
  }

  // 'Verify Signature' button
  VerifySignatureButton = () => {
    const color = this.state.verificationResult === false
      ? "var(--error-color)" : "var(--success-color)";
    return (<Styles.VerifySignatureButton
      onClick={this.onClickVerifySignature}
      style={{ backgroundColor: color }}
    > Verify Signature </Styles.VerifySignatureButton>);
  };

  /* On click verify signature button */
  onClickVerifySignature = async () => {
    const {
      serviceId, state, code, metaId: did, sampleStringData: data, signature, type,
    } = this.state.input;

    let typeNumber = type;
    if (typeof type !== 'number') {
      typeNumber = Number(type);
    }

    // Request backend server to verify signature
    const result = await verifySignatureRequest({ serviceId, state, code, type: typeNumber, data, signature, did });
    this.setState({
      signatureVerificationResult: result,
      modalVisible: true,
    });
  }

  /* On click confirm button of modal window */
  onClickConfirm = () => {
    this.setState({ modalVisible: false })
  }

  // Input change 이벤트 헨들러
  handleChange = (e) => {
    const { name, value } = e.target;
    const input = this.state.input;
    input[name] = value;
    this.setState({ input });
  }
}

export default function3_result;
